import { render, staticRenderFns } from "./LinearRegression.vue?vue&type=template&id=b2bfb73c&scoped=true"
import script from "./LinearRegression.vue?vue&type=script&lang=js"
export * from "./LinearRegression.vue?vue&type=script&lang=js"
import style0 from "./LinearRegression.vue?vue&type=style&index=0&id=b2bfb73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bfb73c",
  null
  
)

export default component.exports